import React from 'react'

const FormatToolbar = (props) => {
    return (
        <div className="format-toolbar">
            {props.children}
        </div>
    )
}

export default FormatToolbar;